module.exports = __webpack_public_path__ + "img/bike.cccb40fa.jpg";